import { api, LightningElement } from "lwc";

import { getClient } from "@devforce/trailhead-client-api";
import { logger } from "@devforce/trailhead-client-logger";

import { trackUserActivity, TrackEvent } from "common/track";

import {
  InboxNotificationUtil,
  API_MAX_MESSAGE_COUNT,
} from "./lib/inboxNotification";
import type { Config } from "./types";
export type { Config };

export default class extends LightningElement {
  @api modulePath: string = "/api/v1/ui/chrome.js";
  @api lxSearch: boolean = false;

  private config: Config = null!;
  private showLxSearch: boolean = false;
  private showThSearch: boolean = false;

  private setSearch() {
    if (this.config.search) {
      if (this.lxSearch) this.showLxSearch = true;
      else this.showThSearch = true;
    }
  }

  connectedCallback() {
    getClient()
      .import<{ header: Config }>(this.modulePath)
      .then(({ header }) => {
        this.config = header;
        this.template.host.style.minHeight = "";
        requestAnimationFrame(() => {
          this.dispatchEvent(new CustomEvent("ready"));
        });
      })
      .then(() => {
        this.setSearch();
      })
      .then(() => this.setInboxNotificationConfig())
      .catch((e: Error) => logger.warn(e.message));
  }

  private handleTrack(e: TrackEvent<"tds-header">) {
    let label = e.detail.payload?.label ?? "";
    let pageLocation = "th-header";
    switch (e.detail.eventName) {
      case "app_launcher_opened": {
        return trackUserActivity(this, "app_launcher_clicked", {
          pageLocation,
        });
      }
      case "nav_item_clicked": {
        return trackUserActivity(this, "nav_clicked", {
          label,
          pageLocation,
        });
      }
      case "signin_clicked": {
        return trackUserActivity(this, "cta_clicked", {
          ctaType: "secondary",
          label,
          pageLocation,
        });
      }
      case "signup_clicked": {
        return trackUserActivity(this, "cta_clicked", {
          ctaType: "primary",
          label,
          pageLocation,
        });
      }
      case "profile_link_clicked": {
        // TODO enable once event is added to trailhead-messaging
        /*const isProfileLink = !!e.detail.payload!.href?.match(
          /\/id(\?lang=.+)?$/
        );
        return isProfileLink
          ? trackUserActivity(this, "my_profile_clicked", {
              label,
              pageLocation,
            })
          : undefined;*/
        break;
      }
      default:
        return trackUserActivity(this, e.detail.eventName, {
          label: e.detail.payload?.label,
          pageLocation,
        });
    }
  }

  private setInboxNotificationConfig() {
    const { inboxNotification } = this.config;
    if (!inboxNotification) return;
    // Fetch and set inbox unread count.
    const util = new InboxNotificationUtil(inboxNotification.apiUrl);
    return util.getUnreadMessageCount().then((unreadCount) => {
      this.config = {
        ...this.config,
        inboxNotification: {
          ...inboxNotification,
          unreadCount,
          maxCount: API_MAX_MESSAGE_COUNT,
        },
      };
    });
  }
}
